var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('results-stats',{attrs:{"checks":_vm.check_totals,"statuses":_vm.status_totals}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('tables-container',{attrs:{"tables-data":_vm.localTableData}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }